var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('div',{staticClass:"px-3 py-2 items-center",class:{'flex' : _vm.labelLeft}},[_c('div',{staticClass:"text-xs"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"text-2xl",class:{'ml-5' : _vm.labelLeft, 'pt-5': !_vm.labelLeft}},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }